<template>
  <div>
    <v-dialog
      v-model="finished"
      max-width="400"
    >
      <v-card
        flat
        class="pa-5"
      >
        <p>Objednávka byla odeslána. O dalším vyřízení Vás budeme informovat na e-mailu.</p>
        <v-btn
          @click="finished = false"
          variant="flat"
          rounded="xl"
          size="x-large"
          color="#cd9b3a"
          class="text-white mt-5"
        >OK</v-btn>
      </v-card>
    </v-dialog>

    <form @submit.prevent="submit">
      <hr>
      <h2>Vyberte si masáž z naší nabídky</h2>
      <v-radio-group
        v-model="form.selectedItem"
        :error-messages="getViolation('selectedItem')"
        class="thirds radios"
      >
        <div
          v-for="(item, index) in items"
          :key="'item' + index"
          class="radio-wrap"
        >
          <v-radio
            :id="'radio-' + item.id"
            :value="item.id"
            color="#cd9b3a"
          />
          <label :for="'radio-' + item.id">
            <span>{{ item.name }}</span>
            <small>{{ item.price }}</small>
          </label>
        </div>
      </v-radio-group>
      <hr>
      <h2>Kolik voucherů si přejete?</h2>
      <div class="thirds">
        <v-text-field
          v-model="form.quantity"
          :error-messages="getViolation('quantity')"
          label="Počet"
          variant="outlined"
          color="#cd9b3a"
          class="mt-5"
        />
      </div>
      <hr>
      <h2>Jak chcete za voucher zaplatit?</h2>
      <v-radio-group
        v-model="form.paymentMethod"
        :error-messages="getViolation('paymentMethod')"
      >
        <div class="halfs">
          <div
            v-for="paymentMethod in paymentMethods"
            :key="'payment-method-' + paymentMethod.id"
            class="radio-wrap"
          >
            <v-radio
              :id="'payment-method-' + paymentMethod.id"
              :value="paymentMethod.id"
              color="#cd9b3a"
            />
            <label for="radio-1">
              <span>{{ paymentMethod.name }}</span>
              <small>{{ paymentMethod.description }}</small>
            </label>
          </div>
        </div>
        <div class="halfs">
          <em>Bez garance vrácení peněz. Jedná se o jednorázovou platbu za elektronický voucher s omezenou platností na 6 měsíců od data nákupu. Elektronický voucher obdržíte ve formátu .pdf a při uplatnění jej musíte předložit vytištěný.</em>
        </div>
      </v-radio-group>
      <hr>
      <h2>Údaje o zákazníkovi</h2>
      <div class="thirds">
        <v-text-field
          v-model="form.firstName"
          :error-messages="getViolation('firstName')"
          label="Jméno"
          variant="outlined"
          color="#cd9b3a"
          class="mt-5"
        />

        <v-text-field
          v-model="form.lastName"
          :error-messages="getViolation('lastName')"
          label="Příjmení"
          variant="outlined"
          color="#cd9b3a"
          class="mt-5"
        />
      </div>
      <div class="thirds">
        <v-text-field
          v-model="form.street"
          :error-messages="getViolation('street')"
          label="Ulice a ČP"
          variant="outlined"
          color="#cd9b3a"
          class="mt-5"
        />

        <v-text-field
          v-model="form.city"
          :error-messages="getViolation('city')"
          label="Město"
          variant="outlined"
          color="#cd9b3a"
          class="mt-5"
        />

        <v-text-field
          v-model="form.postCode"
          :error-messages="getViolation('postCode')"
          label="PSČ"
          variant="outlined"
          color="#cd9b3a"
          class="mt-5"
        />
      </div>
      <div class="thirds">
        <div>
          <v-text-field
            v-model="form.phone"
            :error-messages="getViolation('phone')"
            label="Telefon"
            variant="outlined"
            color="#cd9b3a"
            class="mt-5"
          />

          <v-text-field
            v-model="form.email"
            type="email"
            label="E-mail"
            variant="outlined"
            color="#cd9b3a"
            class="mt-5"
            :error-messages="getViolation('email')"
          />
        </div>
        <div class="span-2">
          <v-textarea
            v-model="form.note"
            :error-messages="getViolation('note')"
            label="Poznámka"
            variant="outlined"
            color="#cd9b3a"
            class="mt-5"
          />
        </div>
      </div>
      <hr>
      <div class="d-flex justify-center">
        <div class="radio-wrap">
          <v-checkbox
            id="vop"
            v-model="terms"
            value="1"
            color="#cd9b3a"
            hide-details
          />
          <label for="vop">
            <span>Souhlasím s níže uvedenými podmínkami.</span>
          </label>
        </div>
      </div>
      <p class="text-center">
        <strong>Potvrzením objednávky se zavazujete k platbě.<br>
          STORNO – objednanou službu lze zrušit nejpozději 24 hodin předem, jinak propadá bez náhrady.<br>
          PO PLATNOSTI – pokud nevyužitý dárkový poukaz budete chtít uplatnit po uplynutí doby platnosti, účtujeme za obnovení 40 % ceny dárkového poukazu</strong>
      </p>
      <div class="d-flex justify-center mt-10">
        <v-btn
          type="submit"
          :loading="loading"
          :disabled="!terms"
          variant="flat"
          rounded="xl"
          size="x-large"
          color="#cd9b3a"
          class="text-white"
        >
          Závazně objednat
        </v-btn>
      </div>
    </form>
  </div>
</template>

<script>
import Axios from '../ajax'
import Qs from 'qs'
import { errorMixin } from '../mixins/error-mixin'

export default {
  name: 'VFormVoucher',
  mixins: [
    errorMixin
  ],
  props: {
    items: {
      type: Array,
      required: true
    },
    paymentMethods: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      finished: false,
      terms: false,
      form: {
        selectedItem: null,
        paymentMethod: null,
        quantity: 1,
        firstName: null,
        lastName: null,
        street: null,
        city: null,
        postCode: null,
        phone: null,
        email: null,
        note: null
      }
    }
  },
  computed: {

  },
  methods: {
    async submit () {
      this.loading = true
      this.clearViolations()
      try {
        await Axios.post('/darkove-poukazy', Qs.stringify(this.form))
        this.finished = true
        this.loading = false
        this.form = {
          selectedItem: null,
          paymentMethod: null,
          quantity: 1,
          firstName: null,
          lastName: null,
          street: null,
          city: null,
          postCode: null,
          phone: null,
          email: null,
          note: null
        }
      } catch (e) {
        console.error(e)
        this.buildViolations(e.response)
        this.loading = false
      }
    }
  }
}
</script>
